import { AppPalette } from '../../colors'

// import { Theme } from '@mui/material/styles'
declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    primary_gradient: true
    secondary: true
    primary: true
    outline_edit: true
    remove: true
  }
}
export const MuiButton = {
  styleOverrides: {
    root: {
      backgroundColor: '#e6eded',
      textTransform: 'none',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '115%',
      color: '#004744',
      borderRadius: '5px',
      '&.Mui-disabled': {
        backgroundColor: '#e6eded',
        opacity: '0.5',
        color: '#000',
      },
      '&:hover': {
        backgroundColor: '#e6eded',
        color: '#004744',
      },
    },
  },
  variants: [
    {
      props: {
        variant: 'primary',
      },
      style: {
        backgroundColor: '#004744',
        textTransform: 'none',
        fontWeight: '400',
        fontSize: '12px',
        lineHeight: '115%',
        color: '#FFF',
        borderRadius: '5px',
        '&.Mui-disabled': {
          backgroundColor: '#004744',
          opacity: '0.3',
          color: '#fff',
        },
        '&:hover': {
          backgroundColor: '#004744',
          color: '#FFF',
        },
      },
    },
    {
      props: {
        variant: 'secondary',
      },
      style: {
        backgroundColor: '#e6eded',
        textTransform: 'none',
        fontWeight: '500',
        fontSize: '12px',
        lineHeight: '14px',
        color: '#004744',
        borderRadius: '5px',
        '&.Mui-disabled': {
          backgroundColor: '#004744',
          opacity: '0.3',
          color: '#000',
        },
        '&:hover': {
          backgroundColor: '#e6eded',
          color: '#004744',
        },
      },
    },
    {
      props: { variant: 'dashed' },
      style: {
        textTransform: 'none',
        border: `2px dashed blue}`,
      },
    },
    {
      props: { variant: 'cancel' },
      style: {
        textTransform: 'none',
        backgroundColor: '#e6eded',
        'hover:': {
          backgroundColor: '#e6eded',
        },
      },
    },
    {
      props: { variant: 'dashed', color: 'secondary' },
      style: {
        border: `4px dashed red`,
      },
    },
    {
      props: {
        variant: 'primary_gradient',
      },
      style: {
        backgroundColor: '#428BCA',
        backgroundImage: `linear-gradient(to bottom, #428BCA 0, #2d6ca2 100%)`,
        padding: '6px 12px',
        borderRadius: '4px',
        color: 'white',
        textTransform: 'none',
        ':hover': {
          background: '#2d6ca2',
        },
      },
    },
    {
      props: {
        variant: 'outline_edit',
      },
      style: {
        backgroundColor: 'transparent',
        padding: '6px 12px',
        borderRadius: '4px',
        color: AppPalette.BLUE.lighter,
        textTransform: 'none',
        ':hover': {
          background: '#2d6ca2',
        },
      },
    },
    {
      props: { variant: 'remove' },
      style: {
        textTransform: 'none',
        backgroundColor: '#EFEFEF',
        'hover:': {
          backgroundColor: '#999999',
        },
        color: '#8A8A8A',
        fontWeight: '500',
        fontSize: '12px',
        lineHeight: '14px',
      },
    },
  ],
}
